/* CFAT compact products: preserve the selected product's actual contents and ordering holds. */
(() => {
  'use strict';
  if (window.CFATCompactProduct) { window.CFATCompactProduct.scan(); return; }
  function init(root) {
    if (root.dataset.compactReady) return;
    const form = root.querySelector('[data-cc-form]');
    const source = root.querySelector('[data-cc-variants]');
    const add = root.querySelector('[data-cc-add]');
    const sticky = root.querySelector('[data-cc-sticky]');
    const stickyAdd = root.querySelector('[data-cc-sticky-add]');
    const mainImage = root.querySelector('[data-cc-main-image]');
    let data;
    try { data = JSON.parse(source.textContent); if (!Array.isArray(data.variants)) return; }
    catch (error) { if (add) add.disabled = true; if (stickyAdd) stickyAdd.disabled = true; return; }
    if (!form || !add) return;
    root.dataset.compactReady = 'true';
    const radios = [...form.querySelectorAll('input[name="id"]')];
    const qty = form.querySelector('input[name="quantity"]');
    const selected = () => data.variants.find(v => String(v.id) === form.querySelector('input[name="id"]:checked')?.value);
    const canBuy = v => !!v && data.checkoutEnabled === true && v.verified === true && v.available === true;
    function write(selector, value) { root.querySelectorAll(selector).forEach(el => { el.textContent = value || ''; }); }
    function image(url, alt) {
      if (!mainImage || !url) return;
      mainImage.removeAttribute('srcset'); mainImage.src = url; mainImage.alt = alt || '';
    }
    function render(updateURL = false) {
      const variant = selected();
      if (!variant) { add.disabled = true; if (stickyAdd) stickyAdd.disabled = true; return; }
      const refill = /refill/i.test(variant.title);
      const price = variant.verified ? variant.price : 'Price pending';
      const status = !variant.verified ? 'Price confirmation pending.' : !variant.available ? 'Currently unavailable.' : !data.checkoutEnabled ? 'Ordering opens after launch checks.' : 'In stock';
      write('[data-cc-price]', price); write('[data-cc-sku]', variant.sku || 'To confirm');
      write('[data-cc-status]', status);
      write('[data-cc-short-status]', variant.title + ' \u00b7 ' + (canBuy(variant) ? 'In stock' : 'Not available to order'));
      write('[data-cc-format-fact]', refill ? 'Refill supplies' : variant.title);
      write('[data-cc-format-note]', refill ? 'Replacement supplies only. No bag or case included.' : (data.fullKitNote || 'Complete first aid supplies in the selected container.'));
      add.disabled = !canBuy(variant); if (stickyAdd) stickyAdd.disabled = !canBuy(variant);
      if (qty) {
        if (canBuy(variant) && variant.inventoryPolicy === 'DENY') { qty.max = String(Math.max(0, variant.quantity)); }
        else qty.removeAttribute('max');
      }
      image(variant.image, variant.alt);
      root.querySelectorAll('[data-cc-thumb]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.variantId === String(variant.id))));
      if (updateURL) {
        try { const url = new URL(location.href); url.searchParams.set('variant', String(variant.id)); history.replaceState(null, '', url); }
        catch (error) { /* The editor may restrict history; the selected form remains correct. */ }
      }
    }
    radios.forEach(radio => radio.addEventListener('change', () => render(true)));
    form.addEventListener('submit', event => {
      if (!canBuy(selected())) { event.preventDefault(); add.disabled = true; if (stickyAdd) stickyAdd.disabled = true; return; }
      if (qty && !qty.checkValidity()) { event.preventDefault(); qty.reportValidity(); }
    });
    if (stickyAdd) stickyAdd.addEventListener('click', () => {
      if (!canBuy(selected())) return;
      if (form.reportValidity()) form.requestSubmit(add);
      else qty?.focus();
    });
    root.querySelectorAll('[data-cc-thumb]').forEach(button => button.addEventListener('click', () => {
      image(button.dataset.image, button.dataset.alt);
      root.querySelectorAll('[data-cc-thumb]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
    }));
    root.querySelectorAll('[data-cc-refill]').forEach(link => link.addEventListener('click', event => {
      const radio = radios.find(input => input.value === link.dataset.ccRefill);
      if (!radio) return;
      event.preventDefault(); radio.checked = true; render(true);
      form.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      radio.focus({ preventScroll: true });
    }));
    if (sticky) {
      sticky.hidden = false;
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => { sticky.hidden = entries[0].isIntersecting; }, { threshold: 0 });
        observer.observe(add);
        const onUnload = event => {
          if (event.target.contains(root)) { observer.disconnect(); document.removeEventListener('shopify:section:unload', onUnload); }
        };
        document.addEventListener('shopify:section:unload', onUnload);
      }
    }
    render();
  }
  function scan() { document.querySelectorAll('[data-cfat-compact]').forEach(init); }
  window.CFATCompactProduct = { scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
